import { useMutation, useQuery, type UseMutationResult, type UseQueryResult } from "@tanstack/react-query";
import { staffClassesReportSchema, type StaffClassesReport } from "@teamna/shared";
import { api } from "../api/client.ts";
import { queryKeys } from "./keys.ts";

/**
 * Owner reports. Owner and admin only: the API refuses staff, because a report such as classes per
 * staff member is pay data.
 */

const reportsBase = (businessId: string) => `/owner/businesses/${businessId}/reports`;

/** GET /v1/owner/businesses/:id/reports/staff-classes?month=yyyy-MM */
export function useStaffClasses(businessId: string | null, month: string): UseQueryResult<StaffClassesReport> {
  return useQuery({
    queryKey: queryKeys.owner.staffClasses(businessId ?? "none", month),
    queryFn: () => api.get(`${reportsBase(businessId ?? "")}/staff-classes`, staffClassesReportSchema, { query: { month } }),
    enabled: Boolean(businessId),
    staleTime: 60 * 1000,
  });
}

/** GET /v1/owner/businesses/:id/reports/staff-classes/export?month=yyyy-MM: the CSV file as text. */
export function useExportStaffClasses(businessId: string): UseMutationResult<string, Error, { month: string }> {
  return useMutation({
    mutationFn: ({ month }) => api.getText(`${reportsBase(businessId)}/staff-classes/export`, { query: { month } }),
  });
}
